import React, { Component } from "react";
import { encode } from "../../utils";

class Newletter extends Component {
  constructor(props) {
    super(props);
    this.state = { status: "init", email: "", name: "" };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = e => {
    e.preventDefault()
      let url = `${process.env.GATSBY_API_BASE_URL}/api/v1/marketplace/forms`;
      this.setState({ status:"submitting" });
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.GATSBY_API_ACCESS_TOKEN}`,
        },
        body: JSON.stringify({
          firstName:this.state.name,
          email: this.state.email,
          newsLetterRequest: {
            isNewsLetter: true
          },
        }),
      })
        .then((res) => {
          this.setState({ status: "success", email: "", name: "" });
          this.setState({ status: "success", email: "", name: "" });
        })
        .catch((err) => {
          this.setState({ status: "failed"});
          console.log(err);
        });
    }
  render() {
    return (
      <div
        className="cta bg-image bg-dark pt-4 pb-5 mb-0"
        style={{ backgroundImage: `url(/assets/images/home/bg-5.jpg)` }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-10 col-md-8 col-lg-6">
              <div className="cta-heading text-center">
                <h3 className="cta-title text-white">
                  Subscribe to our Newsletter
                </h3>
                <p className="cta-desc text-white">
                  Subscribe to our newsletter for special
                  <span className="font-weight-normal">
                    discounts, promotions, and new inventory
                  </span>{" "}
                  updates that you won't want to miss.
                </p>
              </div>

              <form
                className="subscribe-form"
                name="subscribe"
                method="POST"
                data-netlify="true"
                netlify-honeypot="bot-field"
                onSubmit={this.handleSubmit}
              >
                <input type="hidden" name="form-name" value="subscribe" />
                <input
                  type="hidden"
                  name="bot-field"
                  onChange={this.handleChange}
                />

                <div className="input-group ">
                  {/* style={ isIEBrowser() ? { border: 'none' } : {} } */}
                  <input
                    type="email"
                    className="form-control form-control-white"
                    placeholder="Enter your Email Address"
                    aria-label="Email Adress"
                    required
                    name="email"
                    onChange={this.handleChange}
                  />
                </div>

                <div className="input-group ">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Enter your name"
                    onChange={this.handleChange}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-primary"
                      disabled={
                        this.state.status === "submitting" ||
                        this.state.status === "success"
                      }
                      type="submit"
                    >
                      <span>Subscribe</span>
                      <i className="icon-long-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </form>
              {this.state.status === "success" && (
                <div className="text-success text-center">
                  <i className="fa fa-check-circle" aria-hidden="true"></i>{" "}
                  You've successfully subscribed our Newsletter.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Newletter;
